import { brandMemberSegmentApi } from "../api/brandMemberSegmentApi";
import { getToken } from "../utils/getToken";
import {
  BrandMemberSegment,
  BrandMemberSegmentDraft,
} from "../models/brandMemberSegment";

export const brandMemberSegmentService = {
  getBrandMemberSegment: async (brandId: string): Promise<string | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (brandId) {
        const response = await brandMemberSegmentApi.getBrandMemberSegment(
          token,
          brandId
        );
        return response.data.result.BrandMemberSegment;
      }
      return null;
    } catch (error) {
      console.error("Failed to fetch Brand Member Segment:", error);
      return null;
    }
  },
  listBrandMemberSegment: async (brandId: string): Promise<any> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (brandId) {
        const response = await brandMemberSegmentApi.listBrandMemberSegment(
          token,
          brandId
        );
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to fetch Brand Member Segment:", error);
      return null;
    }
  },
  createOrUpdateBrandMemberSegment: async (
    brandId: string,
    segmentData: BrandMemberSegmentDraft
  ): Promise<any> => {
    try {
      const token = getToken();
      if (!token) return false;
      if (brandId && segmentData) {
        const response =
          await brandMemberSegmentApi.createOrUpdateBrandMemberSegment(
            token,
            brandId,
            segmentData
          );
        return response.data;
      }
      return false;
    } catch (error) {
      console.error("Failed to Create or Update Brand Member Segment:", error);
      return false;
    }
  },
  BulkBrandMemberSegment: async (
    segmentData: BrandMemberSegment[]
  ): Promise<any> => {
    try {
      const token = getToken();
      if (!token) return false;
      if (segmentData) {
        const response = await brandMemberSegmentApi.BulkBrandMemberSegment(
          token,
          segmentData
        );
        return response.data;
      }
      return false;
    } catch (error) {
      console.error("Failed to Bulk Update Brand Member Segment:", error);
      return false;
    }
  },
  deleteBrandMemberSegment: async (id: number): Promise<any> => {
    try {
      const token = getToken();
      if (!token) return false;
      if (id) {
        const response = await brandMemberSegmentApi.deleteBrandMemberSegment(
          token,
          id
        );
        return response.data;
      }
      return false;
    } catch (error) {
      console.error("Failed to delete Brand Member Segment:", error);
      return false;
    }
  },
  deleteBrandMemberSegmentDetail: async (id: number): Promise<any> => {
    try {
      const token = getToken();
      if (!token) return false;
      if (id) {
        const response =
          await brandMemberSegmentApi.deleteBrandMemberSegmentDetail(token, id);
        return response.data;
      }
      return false;
    } catch (error) {
      console.error("Failed to delete Brand Member Segment:", error);
      return false;
    }
  },
  resetBrandMemberSegment: async (brandId: string): Promise<string | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (brandId) {
        const response = await brandMemberSegmentApi.resetBrandMemberSegment(
          token,
          brandId
        );
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to reset segment:", error);
      return null;
    }
  },
  getDefaultBrandMemberSegment: async (
    brandId: string
  ): Promise<string | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (brandId) {
        const response =
          await brandMemberSegmentApi.GetDefaultBrandMemberSegment(
            token,
            brandId
          );
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error(
        "Failed to fetch default brand member segment, brandId: ",
        error
      );
      return null;
    }
  },
};
